// removed by extract-text-webpack-plugin
module.exports = {"paragraph":"Gcfaf09","bold":"G80b9e0 G42bbcd"};